module.exports = function() {
  return new Worker(__webpack_public_path__ + "f1f716d083df6964f9d2.worker.js");
};